import React, { useState } from 'react';
import { UpstartApplicationStatus } from '@upstart/harmony/lib/legos/financingTypes';
import PanelBody from 'react-bootstrap/lib/PanelBody';
import PanelHeading from 'react-bootstrap/lib/PanelHeading';
import { Button, Panel } from 'react-bootstrap';

export function DQReasonsPanel(props: {
  applicationStatus?: UpstartApplicationStatus;
}) {
  const [showDetails, setShowDetails] = useState(false);
  const reasonString =
    props.applicationStatus?.adverseActionNoticeInfo?.reasons?.reduce(
      (a, b) => `${a}${b.symbol} - ${b.string}\n`,
      '',
    ) ||
    'Hard credit pull failed for user. Adverse Action Notice was not generated for this application. The application has not been rejected or cancelled at this stage';

  return (
    <Panel className="dqReasonsPanel">
      <PanelHeading>
        <div className="flex-row" style={{ justifyContent: 'space-between' }}>
          <div>
            <i className="glyphicon glyphicon-alert" />{' '}
            <span className="denial-text">Applicant Was Denied</span>
          </div>
          <div className="expand-reasons">
            READ MORE{' '}
            <Button onClick={() => setShowDetails(!showDetails)}>
              <i
                className={
                  !showDetails
                    ? 'glyphicon glyphicon-chevron-down'
                    : 'glyphicon glyphicon-chevron-up'
                }
              />
            </Button>
          </div>
        </div>
      </PanelHeading>
      {showDetails && <PanelBody>{reasonString}</PanelBody>}
    </Panel>
  );
}
